import React from "react";

const ColoredLine = ({ text }) => (
  <div class="form-col1_1" style={{marginBottom:'5px'}}>
    <div class="form-col1_3">
        <p style={{color: 'green', fontWeight: 'bold'}}>{text}</p>
    </div>
    <div class="form-col4_6"
      style={{
        background: "gray",
        height: "1px",
      }}
    >
    </div>
  </div>
);

export default ColoredLine;
